module.exports = "/_next/static/images/7ad7efa3132303ff313488ee25024b8a-blog3a-lg.jpg.webp";